import { createStore, applyMiddleware } from 'redux';
import reduxThunk from 'redux-thunk';
import rootReducer, {RootState} from './reducers'
import {TypedUseSelectorHook, useSelector} from 'react-redux'

export default createStore(rootReducer, applyMiddleware(reduxThunk));
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

// const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
//
// export default createStore(
//     rootReducer,
//     composeEnhancers(applyMiddleware(reduxThunk))
// );
